import { useDispatch, useSelector } from 'react-redux'
import { Element } from '../../../../common/html/element'
import { Tabs } from '../../../../common/tabs'
import { CRITERIA_GROUP } from '../../common/constant'
import { changeGroupTab, selectCurrentGroupTab } from '../store/slice'
import { BasicInformation } from './basicInformation'
import { Financials } from './financials'
import classes from './index.module.scss'
import { Industry } from './industry'

export const CriteriaGroupTab = () => {
  const dispatch = useDispatch()
  const currentGroupTab = useSelector(selectCurrentGroupTab)

  const onChangeTab = (key) => {
    dispatch(changeGroupTab(key))
  }

  return (
    <Element className={classes.select}>
      <Tabs
        items={[
          {
            key: CRITERIA_GROUP.BASIC_INFORMATION,
            label: 'screening.BASIC_INFORMATION',
            children: <BasicInformation />,
          },
          {
            key: CRITERIA_GROUP.INDUSTRY,
            label: 'screening.INDUSTRY',
            children: <Industry />,
          },
          {
            key: CRITERIA_GROUP.FINANCIALS,
            label: 'screening.FINANCIALS',
            children: <Financials />,
          },
        ]}
        activeKey={currentGroupTab}
        onChange={onChangeTab}
        tabListClassName={classes.px20}
        getAppendStyleItem={(active) => ({
          textShadow: active ? '0 0 0.3px currentcolor' : 'unset',
        })}
      />
    </Element>
  )
}
